import { PayloadAction } from "@reduxjs/toolkit"

export const reducers = {
    setUpdatePaymentLoading: (state: any, action: PayloadAction<boolean>) => {
        state.paymentLoading = action.payload
    },
    setZiinaAndroidError: (state: any, action: PayloadAction<string | null>) => {
        state.ziinaAndroidError = action.payload
    },
}